import React from 'react';
import './InfoBox.css';

/**
 * Standardisierte Hinweiskarte (Info, Warnung, Fehler, Erfolg).
 * 
 * @component InfoBox
 * @param {Object} props
 * @param {'info' | 'warning' | 'error' | 'success'} [props.variant='info'] - Variante der Info-Box.
 * @param {string} [props.icon] - Optionales Icon/Emoji.
 * @param {string} [props.title] - Optionaler Titel der Box.
 * @param {React.ReactNode} props.children - Inhaltstext/Inhaltselemente.
 */
export default function InfoBox({ variant = 'info', icon, title, children }) {
    return (
        <div className={`co-info-box ${variant}`}>
            {icon && <span className="co-info-box-icon">{icon}</span>}
            <div className="co-info-box-body">
                {title && <div className="co-info-box-title">{title}</div>}
                <div className="co-info-box-description">{children}</div>
            </div>
        </div>
    );
}
